/* global videoJs */
import helpers from '../helpers';

function init(container) {
	$(container).find('.video-js').each((index, item) => {
		const $video = $(item);
		const $parent = $video.parent();

		let player = $parent.data('player');
		let video10secInterval = null;
		let isPlayed = false;

		const name = $video.data('name');

		if (player) {
			return;
		}

		player = videoJs(item, {
			poster: $video.attr('poster'),
			fluid: true,
			aspectRatio: '1200:675',
			html5: {
				nativeAudioTracks: false,
				nativeVideoTracks: false,
				nativeTextTracks: false,
			},
			hls: {
				overrideNative: true,
			},
		});

		$parent.data('player', player);

		player.on('play', () => {
			if (!$parent.find('.video-js').hasClass('is-playing')) {
				$parent.find('.js-video-play').fadeOut();
				$parent.find('.video-js').addClass('is-playing');
			}

			if (!isPlayed) {
				helpers.$document.trigger('video-first-click', [name]);

				isPlayed = true;
			}

			clearInterval(video10secInterval);

			helpers.$document.trigger('video-play', [name]);

			video10secInterval = setInterval(() => {
				helpers.$document.trigger('video-10-sec', [name]);
			}, 10000);
		});

		player.on('pause', () => {
			clearInterval(video10secInterval);
		});

		player.on('ended', () => {
			helpers.$document.trigger('video-end', [name]);

			clearInterval(video10secInterval);
		});

		helpers.$document.on('videoStop', () => {
			player.pause();
			player.currentTime(0);
		});

		objectFitVideos();
	});
}

function destroy(container) {
	$(container).find('.video-js').each((index, item) => {
		if ($(item).hasClass('is-inited')) {
			videoJs(item).dispose();
		}
	});
}

export default {
	init,
	destroy,
};
